import type { AttentionItem } from '../types';

const getMockAttentionItems = (): AttentionItem[] => [
    {
        id: 'att_initech',
        name: 'Initech',
        reason: 'Negative margin · usage grew 2× on Growth plan',
    },
    {
        id: 'att_globex',
        name: 'Globex',
        reason: 'Past due · still $384 cost in July',
    },
    {
        id: 'att_umbrella',
        name: 'Umbrella Ops',
        reason: 'Usage without payment · 4,210 steps',
    },
];

export default getMockAttentionItems;
